<template>
    <main :class="bodyClass">
        <slot></slot>
    </main>
</template>

<script>
    export default {
        props: {
            padding: { type: String, default: 'medium' },
            className: { type: String, default: undefined },
        },

        computed: {
            bodyClass() {
                return {
                    'page-plain': true,
                    [`page-plain--padding-${this.padding}`]: true,
                    [`page-plain__modal-${this.className}`]: this.className,
                }
            },
        },
    }
</script>
